"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore next */
var Table_1 = require("./Table");
/* istanbul ignore next */
exports.default = Table_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Table/index.js
// module id = 1363
// module chunks = 8